/** Clinic-supplied Provio collection for offered sampling locations. */
export const PROVIO_MAP_COLLECTION =
  "goteborgskliniken-drog/ven/unilabs/Synlab/giddir";

/** Embed URL used by Provio's embed.js (new-map/v2). */
export const samplingMapEmbedUrl =
  `https://provio.nu/new-map/v2/${encodeURIComponent(PROVIO_MAP_COLLECTION)}/?embed=true`;

/** Full map page for "open in new tab" (slashes kept, as Provio expects). */
export const samplingMapPageUrl =
  `https://provio.nu/new-map/?map=${PROVIO_MAP_COLLECTION}`;

export const samplingPagePaths = {
  sv: "/provtagning",
  en: "/en/sample-collection",
} as const;
